import React from 'react';
import { Redirect } from 'react-router';

import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Typography from "@material-ui/core/Typography";

import Api from '../../../../../../common/api';
import Util from '../../../../../../common/util';

import Link from '@material-ui/core/Link';
import PopAlert from '../../../../shared/components/pop-alert';
import StandardInput from '../../../../shared/components/gn-standard-input';
import withTranslations from '../../../../../../common/components/with-translations';
import { withPortalSettings } from '../../../../../../common/portal-settings/provider';

const styles = theme => ({
  button: {
    borderRadius: '9999px',
    fontWeight: '600',
    fontSize: '16px',
    height: '55px',
    width: '100%',
  },
  buttonHover: {
    '&:hover': {
      backgroundColor: 'var(--button-hover-color) !important'
    },
  },
  buttonControls: {
    display: "flex",
    justifyContent: "center",
  },
  infoText: {
    fontSize: '14px'
  },
  linkText: {
    color: '#222222',
    cursor: 'pointer',
    textDecoration: 'underline',
  },
  noHeaderContainer: {
    padding: '20px 20px 0px 20px',
    maxWidth: '1200px',
    margin: '0 auto 50px auto'
  },
  sentInfoText: {
    fontSize: '14px',
    marginBottom: '15px'
  },
  signInText: {
    fontSize: '14px',
    paddingTop: '10px',
    textAlign: 'center'
  },
  view: {
    ...theme.internalContainer,
    [theme.breakpoints.up('md')]: {
      padding: theme.internalContainer._themeMdPadding
    },
  },
  stepTitle: {
    display: "flex",
    justifyContent: "center",
    fontWeight: '600',
    fontSize: '1.2rem',
    marginBottom: '10px',
  }
});

class StepForgotPassword extends React.Component {

  constructor(props) {

    super(props);

    this.state = {
      error: null,
      pop: false,
      username: this.props.username || '',
      sent: false,
      reSent: false,
      validation: {
        username: null
      },
      processing: false,
      redirect: null
    };
    this.api = new Api();
    this.generateOnInput = this.generateOnInput.bind(this);
    this.goCreateAccount = this.goCreateAccount.bind(this);
    this.goSignIn = this.goSignIn.bind(this);
    this.onCreateAccountClick = this.onCreateAccountClick.bind(this);
    this.onError = this.onError.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onSubmitInternal = this.onSubmitInternal.bind(this);
    this.onSubmitPressed = this.onSubmitPressed.bind(this);
    this.onRequestClose = this.onRequestClose.bind(this);
  }

  async componentWillMount() {

    if (this.props.query.aslogin) {
      try {
        await this.onSubmitInternal(this.props.query.aslogin);
        return this.setState({
          username: this.props.query.aslogin,
          sent: true
        });
      }
      catch (e) {
        console.error(e);
        return;
      }
    }

    if (this.props.query.email) {
      this.setState({
        'username': this.props.query.email
      });
    }
  }

  generateOnInput(stateKey) {
    return function (e) {
      this.setState({
        [stateKey]: e.target.value,
        validation: { [stateKey]: null }
      });
    }.bind(this);
  }

  goCreateAccount(e) {
    e.preventDefault();
    this.props.goCreateAccount();
  }

  goSignIn(e) {
    e.preventDefault();
    this.props.goSignIn();
  }

  onCreateAccountClick(e) {
    e.preventDefault();
    this.redirect(`/new-account${Util.toQueryString(this.props.query)}`);
  }

  onError({ error }) {
    this.setState({
      error,
      pop: true
    });
  }

  onRequestClose() {
    this.setState({
      pop: false
    });
  }

  async onSubmit() {
    return await this.onSubmitInternal(this.state.username);
  }

  async onSubmitInternal(username) {
    const { t } = this.props;
    const validation = {
      username: username.length ? null : t('stepForgotPassword.requiredEmailError')
    };
    const that = this;

    if (Object.values(validation).some((v) => { return v !== null; })) {
      return this.setState({ validation });
    }

    try {
      const payload = { username };
      const set = this.props.query.set ? '?set=true' : '';

      if (this.props.query && Object.keys(this.props.query).length) {
        payload.parameters = Util.toCoreQueryObject(this.props.query) || {};
        payload.parameters.username = username;
      }

      this.setState({ processing: true });
      const response = await this.api.post(`/user/authenticate/forgot${set}`, payload);
      this.setState({ processing: false });

      if (response.code > 299) {
        if (response.code === 429) {
          return this.onError({
            error: t('stepForgotPassword.rateLimitedError', { isSet: !!this.props.query.set })
          });
        }

        if (response.code === 400) {
          return this.onError({
            error: function () {
              if (response.content.validation && response.content.validation.keys.length && response.content.validation.keys[0] === 'username') {
                validation.username = t('stepForgotPassword.validEmailError');
                that.setState({ validation });
                return t('stepForgotPassword.invalidEmailError');
              }
              return undefined;
            }() || t('stepForgotPassword.emailMistakeError')
          });
        }

        return this.onError({
          error: t('stepForgotPassword.serverError')
        });
      }

      this.onError({
        error: t('stepForgotPassword.resetEmailSentConfirmation')
      });

      return this.setState({
        username,
        sent: true,
        reSent: this.state.sent,
        validation: { username: null }
      });
    }
    catch (e) {
      this.setState({ processing: false });
      return this.onError({ error: e.toString() });
    }
  }

  async onSubmitPressed(e) {
    if (e.key === 'Enter') {
      return await this.onSubmit();
    }
  }

  render() {
    const { t } = this.props;
    const displayableContent = this.props.application && this.props.application.displayable && this.props.application.displayable.content
      ? this.props.application.displayable.content
      : {};

    const buttonColor = displayableContent.buttonColor || (this.props.query.buttonColor && `#${this.props.query.buttonColor}`);
    const buttonHoverColor = displayableContent.buttonHoverColor || (this.props.query.buttonHoverColor && `#${this.props.query.buttonHoverColor}`);

    const buttonStyle = {
      ...(buttonColor && { backgroundColor: buttonColor }),
      ...(buttonHoverColor && { '--button-hover-color': buttonHoverColor }),
    };

    const buttonClassName = buttonHoverColor ?
      `${this.props.classes.button} ${this.props.classes.buttonHover}` :
      this.props.classes.button;

    const buttonText = this.state.sent ? t('stepForgotPassword.resendButton') : t('stepForgotPassword.sendButton');

    const containerStyle =
      this.props.portal.hideHeader ?
        this.props.classes.noHeaderContainer :
        this.props.classes.view;

    const emailInput = this.state.sent ? null : (
      <Grid item xs={12} md={12}>
        <StandardInput
          inputType="email"
          style={{ marginBottom: '15px' }}
          error={this.state.validation.username}
          attribute="username"
          label={t('stepForgotPassword.emailLabel')}
          labelWidth={85}
          focus={true}
          value={this.state.username}
          onChange={this.generateOnInput('username')}
          onKeyUp={this.onSubmitPressed} />
      </Grid>
    );

    const infoText = this.state.sent ? (
      <Grid item xs={12} md={12}>
        <Typography className={this.props.classes.sentInfoText} color="initial" >
          {t('stepForgotPassword.sentInfo', { username: this.state.username, reSent: this.state.reSent })}
        </Typography>

        <Typography className={this.props.classes.sentInfoText} color="initial" >
          {t('stepForgotPassword.sentExpiryInfo')}
        </Typography>

        <Typography className={this.props.classes.sentInfoText} color="initial" >
          {t('stepForgotPassword.sentCreateAccountQuestion', {
            link: (
              <Link className={this.props.classes.linkText} onClick={this.goCreateAccount} href={`/gn`}>
                {t('stepForgotPassword.sentCreateAccountLinkText')}
              </Link>
            )
          })}
        </Typography>
      </Grid>
    ) : (
      <Grid item xs={12} md={12}>
        <Typography className={this.props.classes.infoText} color="initial" >
          {t('stepForgotPassword.enterEmailInfo')}
        </Typography>
      </Grid>
    )

    const stepTitle = this.props.portal.showSteps ? (
      <Grid className={this.props.classes.stepTitle} item xs={12}>
        <Typography className={this.props.classes.stepTitle}>
          {t('stepForgotPassword.stepTitle')}
        </Typography>
      </Grid>
    ) : null;

    return (
      <Grid container spacing={2} className={containerStyle}>
        <PopAlert open={this.state.pop} message={this.state.error} onClose={this.onRequestClose} />
        {stepTitle}
        {infoText}
        {emailInput}
        <Grid item xs={12} md={12}>
          <Button style={buttonStyle} className={buttonClassName} color="primary" onClick={this.onSubmit} variant="contained">{buttonText}</Button>
        </Grid>
        <Grid item xs={12} md={12}>
          <Typography className={this.props.classes.signInText} color="initial" >
            {t('stepForgotPassword.signInQuestion', {
              link: (
                <Link className={this.props.classes.linkText} onClick={this.goSignIn} to="/gn">
                  {t('stepForgotPassword.signInLinkText')}
                </Link>
              )
            })}
          </Typography>
        </Grid>
      </Grid>
    );
  }
}

export default withPortalSettings(withTranslations(withStyles(styles)(StepForgotPassword)));